module.exports = __webpack_public_path__ + "static/img/meter_1.926888c9.gif";